//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import _ from 'underscore';

export class RequiredFeatures {
    // Local vars
  public showTransclude: boolean;

    // Bindings
  private features: string;
  private disableOnFeature: boolean;

  constructor(
        private sessionVarsService,
    ) {}

  public $onInit() {
    const requiredFeatures = _.chain(this.features.replace(/ /g, '').split(',')).compact().value();
    const lacksRequiredFeatures = _.chain(requiredFeatures)
            .map((feature) => this.sessionVarsService.isFeatureEnabled(feature))
            .contains(false)
            .value();
    const hasRequiredFeatures = !lacksRequiredFeatures;

        // Don't show the element if either:
        // - We lack the required features
        // - We have the required features, but are hiding this element when they are present.
    this.showTransclude = !(
            (lacksRequiredFeatures && !this.disableOnFeature) ||
            (this.disableOnFeature && hasRequiredFeatures)
        );
  }
}

angular.module('curalate').component('requiredFeatures', {
  bindings: {
    features: '@',
    disableOnFeature: '<',
  },
  controller: [
    'SessionVarsService',
    RequiredFeatures,
  ],
  transclude: true,
  template: `<div ng-if="$ctrl.showTransclude">
                    <div ng-transclude></div>
               </div>`,
});
